module.exports = __webpack_public_path__ + "img/ss-savanah.1cf62c38.png";